import { RedisJobStatus } from '../types'
import { get } from './httpHelpers'

export const getJobStatus = (jobId: string) =>
  get<RedisJobStatus>(`jobs/${jobId}`).then((response) => response.parsedBody!['job_data'])
